export { default as TooltipPortal } from "./Tooltip";
export { TooltipProvider, useRegisterTooltip, useTooltipRegistry } from "./TooltipContext";

// Utility to generate data attributes for tooltip triggers
export const getTooltipAttributes = (content, place = "top", options = {}) => {
  const attrs = {
    "data-tooltip-content": content,
    "data-tooltip-place": place,
  };
  if (options.id) attrs["data-tooltip-id"] = options.id;
  if (options.delay !== undefined) attrs["data-tooltip-delay"] = String(options.delay);
  return attrs;
};
